import React, { FC } from 'react';

import { useGeoOmraade } from '../../hooks/useGeoOmraade';
import { ikkeInnenforGeoomraade } from '../../util/geolokasjonUtil';
import UserMessageGeoOmraade from '../modal/userMessageGeoOmraade';

interface Props {
    postnummer: string | null | undefined;
}

const GeoOmraade: FC<Props> = ({ postnummer }) => {
    const { data: geoOmraade, isFetched } = useGeoOmraade();

    return (
        <>{isFetched && geoOmraade && ikkeInnenforGeoomraade(geoOmraade, postnummer) && <UserMessageGeoOmraade />}</>
    );
};

export default GeoOmraade;
